 <template>
    <div>
        <!-- Modal Component -->
        <b-modal v-model="openModal" :title="bid.is_general_bid == 0 ? `Qualification for ${$store.state.user.account_name} Project` : 'New Bid'" size="lg" ok-title="Save" ok-variant="success" :ok-disabled="saving" :cancel-disabled="saving" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="bidModal" :no-close-on-backdrop="true" scrollable>

            <div class="form-group row" v-if="bid.is_general_bid == 0">
                <p class="alert alert-info mx-auto">Please enter as much information as possible.</p>
            </div>

            <div class="form-group row">
                <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.is_general_bid }">Bid Type:</label>
                <div class="col-md-8">
                    <select v-model="bid.is_general_bid" :class="{ 'form-control': true, 'is-invalid': errors.is_general_bid }">
                        <option value="undefined">-- Select a Bid Type --</option>
                        <option value="1">General Bid</option>
                        <option value="0">{{ $store.state.user.account_name }} Project</option>
                    </select>
                    <span v-if="errors.is_general_bid" class="text-danger">
                        <span v-for="error in errors.is_general_bid">{{ error }}</span>
                    </span>
                </div>
            </div>
            <div v-if="bid.is_general_bid == 0">
                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.bid_project_name }">{{ $store.state.user.account_name }} Project Name: <i v-if="!bid.bid_project_name" class="fa fa-asterisk text-danger small"></i></label>
                    <div class="col-md-8">
                        <input type="text" v-model="bid.bid_project_name" :class="{ 'form-control': true, 'is-invalid': errors.bid_project_name }" placeholder="Enter Project Name" />
                        <span v-if="errors.bid_project_name" class="text-danger">
                            <span v-for="error in errors.bid_project_name">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.bid_amount }">Amount: <i v-if="!bid.bid_amount" class="fa fa-asterisk text-danger small"></i></label>
                    <div class="col-md-8">
                        <input type="text" v-model="bid.bid_amount" :class="{ 'form-control': true, 'is-invalid': errors.bid_amount }" placeholder="Enter Bid Amount" />
                        <span v-if="errors.bid_amount" class="text-danger">
                            <span v-for="error in errors.bid_amount">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <hr/>

                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.estimated_date_onsite }">Estimated Date On-Site:</label>
                    <div class="col-md-8">
                        <date-picker v-model="estimated_date_onsite" :config="{format: 'MM/DD/YYYY', useCurrent: false, viewMode: 'months'}" placeholder="Enter Estimated Date On-Site"></date-picker>

                        <span v-if="errors.estimated_date_onsite" class="text-danger">
                            <span v-for="error in errors.estimated_date_onsite">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.estimator_name }"> Name of {{ $store.state.user.account_name }} Contact (PM, PE, Estimator, etc.):</label>
                    <div class="col-md-8">
                        <input type="text" v-model="bid.estimator_name" :class="{ 'form-control': true, 'is-invalid': errors.estimator_name }" :placeholder="`Enter name of ${$store.state.user.account_name} PM, PE, or Estimator`" />
                        <span v-if="errors.estimator_name" class="text-danger">
                            <span v-for="error in errors.estimator_name">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.scope_details }">Scope Details: <i v-if="!bid.scope_details" class="fa fa-asterisk text-danger small"></i></label>
                    <div class="col-md-8">
                        <b-form-textarea v-model="bid.scope_details" :class="{'is-invalid': errors.scope_details }" :rows="4" :max-row="8" placeholder="Enter details about the work to be provided"></b-form-textarea>

                        <span v-if="errors.scope_details" class="text-danger">
                            <span v-for="error in errors.scope_details">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.will_subcontract }">If awarded a subcontract by {{ $store.state.user.account_name }}, does your company plan to subcontract all or a portion of awarded scope?</label>
                    <div class="col-sm-8">
                        <b-form-radio-group plain v-model="bid.will_subcontract" class="mt-2">
                            <b-form-radio value="1">Yes</b-form-radio>
                            <b-form-radio value="0">No</b-form-radio>
                        </b-form-radio-group>

                        <span v-if="errors.will_subcontract" class="text-danger">
                            <span v-for="error in errors.will_subcontract">{{ error }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        props: {

            subcontractorId: {
                type: Number,
                default: null,
            },
        },

        data: function() {
            return {
                openModal: false,
                saving: false,
                errors: {},
                bid: {},
                estimated_date_onsite: null,
            }
        },

        methods: {

            handleHide(bvEvt){

            },

            handleHidden(bvEvt){
                //Reset the values
                this.bid = {};
                this.errors = {};
                this.estimated_date_onsite = null;
            },

            handleOk: function(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Do it
               this.saveBid();
            },

            setModel(bid){
                this.bid = JSON.parse(JSON.stringify(bid));
                if (this.bid.estimated_date_onsite)
                {
                    this.estimated_date_onsite =  moment(this.bid.estimated_date_onsite, 'YYYY-MM-DD').format('MM/DD/YYYY');
                }
            },

            showModal(){
                //Open the modal
                this.openModal = true;
            },

            saveBid(){
                //Loading
                this.saving = true;

                if (this.estimated_date_onsite)
                {
                    this.bid.estimated_date_onsite = moment(this.estimated_date_onsite, 'MM/DD/YYYY').format('YYYY-MM-DD');
                }

                //Send it
                this.$http
                .post('subcontractors/bid/' + this.subcontractorId, this.bid)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Bid Saved');

                    //Emit
                    //this.$emit('bidSaved', response.data);
                    this.$store.commit('updateBids', response.data);

                    //Close the modal
                    this.$refs.bidModal.hide();

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //SEt the height
            //this.$refs.bidModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';
        }
    }
</script>